import isEmpty from "lodash/isEmpty";
import React, { useCallback, useContext, useState, useRef, useEffect } from "react"
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Validate } from "../functionsIsmesti/validation";
import { GlobalStates } from "../GlobalStates";
import { useAuth } from "../Hooks/useAuth";
import PrimaryButton from "./Button/PrimaryButton";
import PrimaryTextField from "./PrimaryTextField/PrimaryTextField";

const ForgotPass = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('')
    const { resetPassword: forgot, loading } = useAuth();
    const { setAlert } = useContext(GlobalStates)
    const isActive = useRef(true);

    const handleRedirect = useCallback(() => {
        if (isActive.current) navigate("/?tab=1");
    }, [navigate]);

    const handleSubmit = useCallback(async () => {
        if (!isActive.current || loading) return;

        const isValid = Validate(email, 'email');
        if (!isValid) {
            if (isActive.current) setAlert(t('forgotPass.invalidEmail'));
            return;
        }

        try {
            const { success, error } = await forgot(email);
            if (success) {
                if (isActive.current) {
                    setAlert(t('forgotPass.resetLinkSent'));
                    setEmail('');
                }
            } else {
                if (isActive.current) {
                    setAlert(t('forgotPass.resetError') + (error ? `: ${error.message}`: ''));
                }
                console.error("Password reset error:", error);
            }
        } catch (err) {
            console.error("Unexpected error during password reset:", err);
            if (isActive.current) {
                setAlert(t('forgotPass.resetError') + (err.message ? `: ${err.message}` : ''));
            }
        }
    }, [email, forgot, setAlert, t, loading]);

    useEffect(() => {
        isActive.current = true;
        return () => {
            isActive.current = false;
        };
    }, []);

    return (
        <>
            <div>
                <PrimaryTextField
                    label='login_email'
                    type='text'
                    onChange={setEmail}
                    validate={'email'}
                    fullWidth
                    size={'small'}
                    classNameForm='txtFielfContainer'
                />
            </div>
            <div className='submitButtonCont'>
                <PrimaryButton
                    onClick={handleSubmit}
                    text={'prisiminti'}
                    disabled={isEmpty(email) || loading}
                    className='mobLogIn'
                />
                <PrimaryButton
                    text='registruotis'
                    sx={{
                        boxShadow: 0,':hover': {
                           
                             boxShadow: "0",
                             backgroundColor: "white",
                             },
                     }}
                    onClick={handleRedirect}
                    className='pamirsai_pass'
                    variant="text"
                    disabled={loading}
                />
            </div>
        </>

    )
}
export default ForgotPass
